// @flow

"use strict";


/**
 * プレイスメント情報
 */
export default class Placement{
  constructor(id: number, code: string){
    this.id = id;   // プレイスメントID
    this.code = code; // プレイスメントコード
  }

  static create(id: string, code: string): Placement{
    const placementId = parseInt(id);
    if(isNaN(placementId)){
      throw new Error('placementId parse failed');
    }

    return new Placement(placementId, code);
  }
}


// WEBPACK FOOTER //
// ./src/js/model/common/placement.js